const apiVersion = '2023-07'
const storeFrontApiEndpoint = `https://${window.Shopify.shop}/api/${apiVersion}/graphql.json`
const storeFrontAccessToken = window.storefrontToken
class HHCustomerLogin extends HTMLElement {
  static properties = {
    emailInput: { type: Object },
    passwordInput: { type: Object },
  }
  constructor() {
    super()
    this.emailInput = this.querySelector('#CustomerEmail')
    this.passwordInput = this.querySelector('#CustomerPassword')
    const form = this.querySelector('#customer_login')
    if (form) {
      form.addEventListener('submit', async (event) => {
        if (this.emailInput.value && this.passwordInput.value) {
          event.stopImmediatePropagation()
          event.preventDefault()
          try {
            await this.getCustomerAccessToken()
          } catch (err) {
            console.log({ error: err })
          }
        }
        if (this.hasAttribute('async-request')) {
          const errorMessage = this.querySelector('[data-error]');
          errorMessage?.classList.add('hidden');
          const formData = new FormData(event.target);
          fetch("https://stg-us.myshopify.com/account/login", {
            "headers": {
              "accept": "application/json",
              "content-type": "application/x-www-form-urlencoded",
            },
            "body": new URLSearchParams(formData).toString(),
            "method": "POST",
          }).then(response => {
            if (response.url.includes('login')) {
              errorMessage?.classList.remove('hidden');
            } else {
              document.dispatchEvent(new CustomEvent('customer:login'));
            }
          });
        } else {
          event.target.submit()
        }
      })
    }

    // Login/Recover form
    this.shouldRedirectForgetPassword = this.hasAttribute(
      'redirect-forget-password'
    )

    if (window.location.hash === '#recover') {
      this.toggleFormState('recover')
    } else {
      this.toggleFormState('login')
    }

    if (this.shouldRedirectForgetPassword) {
      this.handleRecoverForm()
    }

    const forgotPasswordButton = this.querySelector('.js-forgot-password')
    forgotPasswordButton?.addEventListener('click', (e) => {
      e.preventDefault()
      this.toggleFormState('recover')
    })

    const cancelRecover = this.querySelector('.js-cancel-recover')
    cancelRecover?.addEventListener('click', (e) => {
      e.preventDefault()
      this.toggleFormState('login')
    })
  }

  toggleFormState(state) {
    if (!state) return
    const login = this.querySelector('#login')
    const recover = this.querySelector('#recover')

    login.classList.toggle('hidden', state === 'recover')
    recover.classList.toggle('hidden', state === 'login')

    history.replaceState(
      {},
      document.title,
      `${window.location.pathname}${window.location.search}${
        state === 'recover' ? '#recover' : ''
      }`
    )

    window.scrollTo(0, 0)
  }

  handleRecoverForm(tries = 3) {
    const hasRecoverHash = window.location.hash === '#recover'
    const hasErrors =
      this.querySelector('.customer__form-container .errors') !== null

    if (hasRecoverHash || hasErrors) {
      this.toggleFormState('recover')
      return
    }

    if (tries > 0) {
      setTimeout(() => {
        this.handleRecoverForm(tries - 1)
      }, 1500)
    }
  }

  async getCustomerAccessToken() {
    try {
      const headers = new Headers()
      headers.append('Content-Type', 'application/json')
      headers.append('X-Shopify-Storefront-Access-Token', storeFrontAccessToken)

      const graphql = JSON.stringify({
        query: this.createGQLMutation(),
        variables: {
          input: {
            email: this.emailInput.value,
            password: this.passwordInput.value,
          },
        },
      })
      const requestOptions = {
        method: 'POST',
        headers,
        body: graphql,
      }

      const req = await fetch(storeFrontApiEndpoint, requestOptions)
      const resp = await req.json()
      const customerAccessToken =
        resp?.data?.customerAccessTokenCreate?.customerAccessToken?.accessToken
      if (customerAccessToken) {
        localStorage.setItem('ShopifyCustomerAccessToken', customerAccessToken)
      }
    } catch (err) {
      console.log({ err })
    }
  }
  createGQLMutation() {
    return `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            field
            message
          }
        }
      }
    `
  }
}
customElements.define('hh-customer-login', HHCustomerLogin)
